import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=0cb2923e&scoped=true"
import script from "./Payouts.vue?vue&type=script&lang=js"
export * from "./Payouts.vue?vue&type=script&lang=js"
import style0 from "./Payouts.vue?vue&type=style&index=0&id=0cb2923e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2923e",
  null
  
)

export default component.exports